<template>
  <v-container grid-list-lg>
    <v-layout row wrap>
      <v-flex xs3 offset-xs1>
        <router-link :to="'/employees'" exact>
          <v-hover>
            <v-card slot-scope="{ hover }"
                    :class="`elevation-${hover ? 12 : 2}`"
                    class="mx-auto">
              <v-img :aspect-ratio="16/9" contain :src="require('../../assets/employees.png')"></v-img>
              <v-card-title class="justify-center">
                <span class="headline">Сотрудники</span>
              </v-card-title>
            </v-card>
          </v-hover>
        </router-link>
      </v-flex>
      <v-flex xs3>
        <router-link :to="'/departments'" exact>
          <v-hover>
            <v-card slot-scope="{ hover }"
                    :class="`elevation-${hover ? 12 : 2}`"
                    class="mx-auto">
              <v-img :aspect-ratio="16/9" contain :src="require('../../assets/departments.png')"></v-img>
              <v-card-title class="justify-center">
                <span class="headline">Отделы</span>
              </v-card-title>
            </v-card>
          </v-hover>
        </router-link>
      </v-flex>
      <v-flex xs3>
        <router-link :to="'/reports'" exact>
          <v-hover>
            <v-card slot-scope="{ hover }"
                    :class="`elevation-${hover ? 12 : 2}`"
                    class="mx-auto">
              <v-img :aspect-ratio="16/9" contain :src="require('../../assets/reports.png')"></v-img>
              <v-card-title class="justify-center">
                <span class="headline">Отчеты</span>
              </v-card-title>
            </v-card>
          </v-hover>
        </router-link>
      </v-flex>
    </v-layout>
    <last-sync-with-database v-if="this.$store.getters.lastEmployeesActionsSync"/>
  </v-container>
</template>

<script>
  import LastSyncWithDatabase from './Last-db-sync'
  export default {
    components: { LastSyncWithDatabase }
  }
</script>

<style scoped>
  a {
    text-decoration: none;
  }
</style>
